import React, { useEffect, useState } from "react";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../../lib/firebase/firebase";

export function messageStatus(message) {
  if (message.direction !== "outbound") return "Received";
  if (message.providerStatus === "SENT" && (message.gmailMessageId || message.providerMessageId)) return "Sent";
  if (message.providerStatus === "ACCEPTED" && message.providerMessageId) return "Accepted by provider";
  if (["SENT", "ACCEPTED"].includes(message.providerStatus)) return "Send status unverified (provider ID missing)";
  return message.providerStatus || "Send status unverified";
}

export default function TicketCorrespondence({ ticket }) {
  const [result, setResult] = useState({ id: null, messages: [], error: false });
  useEffect(() => {
    let cancelled = false;
    getDocs(collection(db, "supportTickets", ticket.id, "correspondence"))
      .then(snapshot => {
        if (!cancelled) setResult({ id: ticket.id, messages: snapshot.docs.map(d => ({ id: d.id, ...d.data() })), error: false });
      }).catch(() => {
        if (!cancelled) setResult({ id: ticket.id, messages: [], error: true });
      });
    return () => { cancelled = true; };
  }, [ticket.id]);
  const messages = result.id === ticket.id ? result.messages : [];
  const time = m => {
    const t = m.sentAt || m.receivedAt || m.createdAt;
    return t?.toMillis?.() ?? (t?.seconds != null ? t.seconds * 1000 : Date.parse(t) || 0);
  };
  return <section className="sop-detail-block">
    <h4>Recorded correspondence</h4>
    {result.id !== ticket.id ? <p>Loading correspondence…</p> : result.error ?
      <p role="alert">Could not load correspondence. The draft below is not proof of a sent reply.</p> :
      !messages.length ? <p>No message records available. Send status cannot be verified from the saved draft.</p> : null}
    {[...messages].sort((a, b) => time(b) - time(a)).map(m => <article key={m.id}>
      <p><strong>{messageStatus(m)}</strong> · {m.from || m.direction} · {time(m) ? new Date(time(m)).toLocaleString() : "Time unavailable"}</p>
      <p>Message ID: {m.gmailMessageId || m.providerMessageId || m.id}</p>
      <p style={{ whiteSpace: "pre-wrap" }}>{m.body}</p>
    </article>)}
    {ticket.lastManualReplyMessageId && <p>Latest manual reply ID: {ticket.lastManualReplyMessageId}</p>}
  </section>;
}
